import React from "react";
import { number, object } from "prop-types";

import WruAlsoRead from "../../molecules/wru-also-read";
import NewsLetter from "./news-letter";
import { AdFree, Standard337x280Container } from "../../rows/ad-free";

import "./story-sidebar.m.css";

const StorySideBar = ({ index, story }) => {
  return (
    <div styleName="side-bar-wrapper">
      <AdFree>
        <div styleName="ad-wrapper">
          <Standard337x280Container adtype="storyPrem1" story={story} />
        </div>
      </AdFree>
      <NewsLetter />
      <WruAlsoRead index={index} />
      <AdFree>
        <div styleName="ad-wrapper">
          <Standard337x280Container adtype="storyPrem2" story={story} />
        </div>
      </AdFree>
    </div>
  );
};

StorySideBar.propTypes = {
  index: number,
  story: object,
};

export default StorySideBar;
